import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'

/**
 * Liste non vide, mais rien ne répond à la recherche ou aux filtres (#107).
 * Distinct du message « aucune donnée » de chaque liste : dire « Aucun groupe »
 * à quelqu'un qui en a vingt, parce qu'il a fait une faute de frappe, l'envoie
 * chercher un bug. `role="status"` : un lecteur d'écran annonce que le filtre
 * vient de vider la liste.
 */
export function NoResults({ query, onReset }: { query: string, onReset: () => void }) {
  const { t } = useTranslation()
  const trimmed = query.trim()

  return (
    <div className="flex flex-col items-center gap-3 p-6 text-center">
      <p role="status" className="text-sm text-muted-foreground">
        {trimmed ? t('common.noResultsFor', { query: trimmed }) : t('common.noResults')}
      </p>
      <Button variant="outline" size="sm" onClick={onReset}>{t('common.reset')}</Button>
    </div>
  )
}
